import { render } from "./DateFormatted.vue?vue&type=template&id=bf22b376"
import script from "./DateFormatted.vue?vue&type=script&lang=js"
export * from "./DateFormatted.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__